enum CustomerLoyaltyProgram {
  LEVE = 'LEVE',
  LEST = 'LEST',
  LESE = 'LESE',
  LEAN = 'LEAN',
  LEUN = 'LEUN',
  SAGA = 'SAGA',
  SAPL = 'SAPL',
  TOTA = 'TOTA',
  TOPL = 'TOPL',
  TOST = 'TOST',
  INTR = 'INTR',
  PRBA = 'PRBA',
}

export default CustomerLoyaltyProgram;
